import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarComprasEmAbertoDashboard(axios) {
    let parametros = {
      operacao: 'buscarComprasEmAbertoDashboard'
    };

    let retorno = {};

    await axios.santriGET('/rest/compra', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RCompra/RCompraBuscarComprasEmAbertoDashboard.js